<div class="apps">
    <div class="user-app" *ngFor="let application of applications; trackBy: byApplicationId">{{ application.text }}</div>
</div>